module.exports = __webpack_public_path__ + "img/icon_exchange_10people.d5e23bc8.png";